import { Injectable } from '@angular/core'
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse } from '@angular/common/http'
import { Observable } from 'rxjs'
import { LoadingService } from '@app/services/loading.service'

@Injectable()
export class LoadingInterceptor implements HttpInterceptor {
  private requests: HttpRequest<any>[] = []

  constructor(private loadingService: LoadingService) {}

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    this.requests.push(request)
    this.loadingStart()

    return new Observable((observer) => {
      const subscription = next.handle(request).subscribe(
        (event) => {
          if (event instanceof HttpResponse) {
            this.removeRequest(request)
            observer.next(event)
          }
        },
        (err) => {
          this.removeRequest(request)
          observer.error(err)
        },
        () => {
          this.removeRequest(request)
          observer.complete()
        }
      )
      // remove request from queue when cancelled
      return () => {
        this.removeRequest(request)
        subscription.unsubscribe()
      }
    })
  }

  removeRequest(request: HttpRequest<any>) {
    const i = this.requests.indexOf(request)
    if (i >= 0) {
      this.requests.splice(i, 1)
    }
    if (this.requests.length === 0) {
      this.loadingEnd()
    }
  }

  private loadingStart(): void {
    this.loadingService.loadingStart()
  }

  private loadingEnd(): void {
    this.loadingService.loadingEnd()
  }
}
